import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../../shared/api-response.model';
import { BasicApiResponseModel } from '../../../shared/api-response.model';

@Injectable({
    providedIn: 'root'
  })
  export class LogisticHubNetworkService extends BaseApiTemplateService<any> {
      
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/logistic-hub-networks/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/logistic-hub-networks/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/logistic-hub-networks/backoffice-ep'
      this.httpClient = http;
    }

    public getLogisticHubNetworks(visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path
        }
        const httpOptions: Object = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            authorization: visa.jwt_secret,
            tenantCode: visa.tenantCode,
          }),
          responseType: 'json',
        };
        return this.httpClient.get<ApiResponseModel<any>>(
          url,
          httpOptions
        );
    }

    public getLogisticHubNetworkGuids(visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/network-hub-guids'
        }
        const httpOptions: Object = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            authorization: visa.jwt_secret,
            tenantCode: visa.tenantCode,
          }),
          responseType: 'json',
        };

        return this.httpClient.get<ApiResponseModel<any>>(
          url,
          httpOptions
        );
    }
}